// Generated by scripts/build-ui-icons.mjs.
export { CaretDoubleDown as default } from "../ui/glyphs-2";
